import axios from 'axios'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 30000
})

service.interceptors.request.use(
  config => {
    const token = Cookies.get('admin_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        // 兼容后端返回结构：如果 code 存在且不等于 200 (或 0，视你们后端定义而定)
        if (res.code && res.code !== 200) {
            Message({
                message: res.message || '请求失败',
                type: 'error',
                duration: 5 * 1000
            })
            if (res.code === 401) {
                Cookies.remove('admin_token')
                router.push('/login')
            }
            return Promise.reject(new Error(res.message || 'Error'))
        }
        return res
    },
    error => {
        console.log(error)
        // 1. 区分错误类型，提供友好提示
        let message = '网络异常，请稍后重试'

        if (error.response) {
            // 服务器返回了状态码 (如 400, 401, 500, 502, 503, 504)
            const status = error.response.status

            switch (status) {
                case 400:
                    message = '请求参数错误'
                    break
                case 401:
                    message = '未授权，请重新登录'
                    Cookies.remove('admin_token')
                    router.push('/login')
                    break
                case 403:
                    message = '拒绝访问'
                    break
                case 404:
                    message = '请求资源不存在'
                    break
                case 500:
                    message = '服务器内部错误 (500)，请联系管理员或稍后重试'
                    break
                case 502:
                    message = '网关错误，服务可能正在重启'
                    break
                case 503:
                    message = '服务暂时不可用'
                    break
                case 504:
                    message = '网关超时'
                    break
                default:
                    message = `连接错误 (${status})`
            }

            // 【重要】如果是开发环境，打印详细错误信息供调试
            if (process.env.NODE_ENV === 'development') {
                console.error('--- 详细错误信息 ---')
                console.error('URL:', error.config.url)
                console.error('Method:', error.config.method)
                console.error('Status:', status)
                console.error('Response Data:', error.response.data) // 这里通常包含后端具体的报错堆栈
                console.error('------------------')
            }

        } else if (error.request) {
            // 请求已发出但没有收到响应 (如断网、服务器宕机无响应)
            message = '无法连接到服务器，请检查网络连接'
            console.error('No response received:', error.request)
        } else {
            // 发送请求时配置出错
            message = '请求配置错误: ' + error.message
            console.error('Request config error:', error.message)
        }

        // 统一弹出提示
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })

        return Promise.reject(error)
    }
)

export default service
